'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_UserProfilePage$Props(mealoramaState) {
  this.zv = null;
  this.zv = mealoramaState;
}
export { $c_Lmealorama_pages_UserProfilePage$Props as $c_Lmealorama_pages_UserProfilePage$Props };
$p = $c_Lmealorama_pages_UserProfilePage$Props.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_UserProfilePage$Props;
/** @constructor */
function $h_Lmealorama_pages_UserProfilePage$Props() {
}
export { $h_Lmealorama_pages_UserProfilePage$Props as $h_Lmealorama_pages_UserProfilePage$Props };
$h_Lmealorama_pages_UserProfilePage$Props.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 418637176, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_UserProfilePage$Props)) {
    var x = this.zv;
    var x$2 = x$0.zv;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "Props";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.zv;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_pages_UserProfilePage$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kJ)));
}
export { $isArrayOf_Lmealorama_pages_UserProfilePage$Props as $isArrayOf_Lmealorama_pages_UserProfilePage$Props };
var $d_Lmealorama_pages_UserProfilePage$Props = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_UserProfilePage$Props, "mealorama.pages.UserProfilePage$Props", ({
  kJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_UserProfilePage$Props as $d_Lmealorama_pages_UserProfilePage$Props };
//# sourceMappingURL=mealorama.pages.-User-Profile-Page$-Props.js.map
